module.exports = __webpack_public_path__ + "img/theme_bg_right.5ef4c72d.png";